import { ArcadeWheelProperties } from "@lib/titan2-slingo/dist/game/view/abstract/display/ArcadeWheel";
/**
 * ArcadeWheelLandscapeProperties.ts
 */
export class ArcadeWheelLandscapeProperties extends ArcadeWheelProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.scaleNotInProgress.set(0.48);
        this.scaleInProgress.set(0.8);
        this.scaleHidden.set(0.48);
        this.offsetNotInProgress.set(150, 145);
        this.offsetInProgress.set(75, 145);
        this.offsetHidden.set(773, 145);
        this.instructionsProperties.position.set(973, 175);
        this.instructionsBackgroundProperties.scale.set(1);
    }
}
